<template>
  <v-container>
    <v-form
      autocomplete="off"
      ref="form"
      v-model="valid"
      @submit.prevent="updatePerformance"
    >
      <v-card flat class="mt-7 pa-5">
        <v-toolbar flat width="100%">
          <v-toolbar-title class="text-h4">Performance</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click="cancelpage"
            outlined
            right
            height="44"
            width="116"
            color="primary"
          >
             {{ $t("cancel") }}
          </v-btn>
          <v-btn
            right
            class="ml-5"
            height="44"
            width="116"
            color="primary"
            type="submit"
          >
            Submit
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-expansion-panels focusable class="mt-5" v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header class="text-h6"
                >Milk information</v-expansion-panel-header
              >
              <v-expansion-panel-content class="pt-5">
                <v-row>
                  <v-col cols="4">
                    <label class="label">Daily Milk Yield</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        v-model="performance.dailyMilkYield"
                        placeholder="e.g. 123"
                        :rules="rules.weight"
                      ></v-text-field>
                      <v-select
                        :items="['Kg','Lb','Litres']"
                        outlined
                        class="ml-4"
                        value="Kg"
                        placeholder="Unit"
                        dense
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Milk Color</label>
                    <div class="d-flex text-capitalize">
                      <v-select
                        :items="milkColours"
                        outlined
                        dense
                        v-model="performance.milkColour"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Milk Taste</label>
                    <div class="d-flex text-capitalize">
                      <v-select
                        :items="milkTastes"
                        outlined
                        dense
                        v-model="performance.milkTaste"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Milk Smell</label>
                    <div class="d-flex text-capitalize">
                      <v-select
                        :items="milkSmells"
                        outlined
                        dense
                        v-model="performance.milkSmell"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Lactation Number</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. (123, 1.5, 1000)"
                        v-model="performance.lactationNumber"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Lactation Length</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="performance.lactationLength"
                      ></v-text-field>
                      <v-select
                        :items="['Days','Weeks', 'Months']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        dense
                        v-model="performance.lactationLengthUnit"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Milking Frequency</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        :rules="[
                          (v) => v >= 0 || 'Can not be less then 0',
                          (v) => v <= 2 || 'Can not be more then 2',
                        ]"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="performance.milkingFrequency"
                      ></v-text-field>
                      <v-select
                        :items="['times']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        value="times"
                        dense
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- TODO:: physiochemical characteristics disabled as per CFA-4708 -->

            <!-- <v-expansion-panel class="mt-2">
              <v-expansion-panel-header class="text-h6"
                >Physiochemical Characteristics</v-expansion-panel-header
              >
              <v-expansion-panel-content class="pt-5">
                <v-row>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.acidityOfRawMilk')}}
                      <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{$t('animal.performanceInfo.acidityOfRawMilk')}}
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        v-model="performance.acidityOfRawMilk"
                        placeholder="e.g. 123"
                        min="1"
                        :rules="rules.weight"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.specificGravity')}}
                      <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{$t('animal.performanceInfo.specificGravity')}}
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        v-model="performance.specificGravity"
                        placeholder="e.g. 123"
                        min="1"
                        :rules="rules.weight"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.snf')}}
                    <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  SNF or solids not fat is nutrient portion present in milk which is other than milk fat and water. It consists of protein (primarily casein and lactalbumin), carbohydrates (primarily lactose), and minerals (including calcium and phosphorus). When SNF is combined with milk fat, then it is called total solids.
The legal standard for standardized milk is 4.5% fat and 8.5% SNF and the total solids are 13%.
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        v-model="performance.snf"
                        placeholder="e.g. 123"
                        min="1"
                        :rules="rules.weight"
                      ></v-text-field>
                      <v-select
                        :items="['%']"
                        outlined
                        class="ml-4"
                        value="%"
                        placeholder="Unit"
                        dense
                      ></v-select>
                    </div>  
                  </v-col>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.proteinContent')}}
                    <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  The concentration of protein in milk varies from 3.0 to 4.0% (30-40 grams per liter). The percentage varies with the breed of the cow, various environmental factors like feed and in proportion to the amount of fat in the milk. There is a close relationship between the amount of fat and the amount of protein in milk-the higher the fat, higher the protein.
Furthermore, milk contains two specific proteins;
Casein: accounts for approximately 80% of the protein in milk.
Whey: around 20% of milk’s protein is in the form of whey
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        v-model="performance.proteinContent"
                        placeholder="e.g. 123"
                        min="1"
                        :rules="rules.weight"
                      ></v-text-field>
                      <v-select
                        :items="['kg/dl','lb/dl']"
                        outlined
                        class="ml-4"
                        v-model="performance.proteinContentUnit"
                        placeholder="Unit"
                        dense
                      ></v-select>
                    </div>  
                  </v-col>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.fatContent')}}
                    <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{$t('animal.performanceInfo.fatContent')}}
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        v-model="performance.fatContent"
                        placeholder="e.g. 123"
                        min="1"
                        :rules="rules.weight"
                      ></v-text-field>
                      <v-select
                        :items="['%']"
                        outlined
                        class="ml-4"
                        value="%"
                        placeholder="Unit"
                        dense
                      ></v-select>
                    </div>  
                  </v-col>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.milkLactose')}}
                    <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  Lactose is the major carbohydrate in milk and its concentration varies with milk yield between 4.2% and
5%, the lactose content usually being lowest in late lactation milk and in milk from animals having mastitis.
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        v-model="performance.milkLactose"
                        placeholder="e.g. 123"
                        min="1"
                        :rules="rules.weight"
                      ></v-text-field>
                      <v-select
                        :items="['%']"
                        outlined
                        class="ml-4"
                        value="%"
                        placeholder="Unit"
                        dense
                      ></v-select>
                    </div>  
                  </v-col>
                  
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel> -->
            <v-expansion-panel class="mt-2">
              <v-expansion-panel-header class="text-h6"
                >Microbiological Characteristics</v-expansion-panel-header
              >
              <v-expansion-panel-content class="pt-5">
                <v-row>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.somaticCellCount')}}
                      <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{$t('animal.performanceInfo.somaticCellCount')}}
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="['<100,000 cells/ml','100000-199999 cells/ml','200000-299999 cells/ml','300000-399999 cells/ml','>400000 cells/ml']"
                        outlined
                        v-model="performance.somaticCellCount"
                        placeholder="Select"
                        dense
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.preliminaryIncubationCounts')}}
                      <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{$t('animal.performanceInfo.preliminaryIncubationCounts')}}
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="['<10,000 cfu/ml','10000-50000 cfu/ml','>50000 cfu/ml']"
                        outlined
                        v-model="performance.preliminaryIncubationCounts"
                        placeholder="Select"
                        dense
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.californiaMastitis')}}
                    <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{$t('animal.performanceInfo.californiaMastitis')}}
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="['Positive','Negative']"
                        outlined
                        v-model="performance.californiaMastitis"
                        placeholder="Select"
                        dense
                      ></v-select>
                    </div>  
                  </v-col>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.totalViableCount')}}
                    <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{$t('animal.performanceInfo.totalViableCount')}}
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="['<5000','5000-10000','>10000']"
                        outlined
                        v-model="performance.totalViableCount"
                        placeholder="Select"
                        dense
                      ></v-select>
                    </div>  
                  </v-col>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.coliformCount')}}
                    <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{$t('animal.performanceInfo.coliformCount')}}
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="['<50','50-100','>100']"
                        outlined
                        v-model="performance.coliformCount"
                        placeholder="Select"
                        dense
                      ></v-select>
                    </div>  
                  </v-col>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.yeastAndMouldCount')}}
                    <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{$t('animal.performanceInfo.yeastAndMouldCount')}}
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="['<30>','30-50','>50']"
                        outlined
                        v-model="performance.yeastAndMouldCount"
                        placeholder="Select"
                        dense
                      ></v-select>
                    </div>  
                  </v-col>
                  <v-col cols="4">
                    <label class="label">{{$t('animal.performanceInfo.antimicrobialResidues')}}
                    <v-tooltip top color="black" max-width="350">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon v-bind="attrs" v-on="on">
                                    mdi-help-circle-outline
                                  </v-icon>
                                </template>
                                <span>
                                  {{$t('animal.performanceInfo.antimicrobialResidues')}}
                                </span>
                     </v-tooltip>
                    </label>
                    <div class="d-flex">
                      <v-select
                        :items="['Negative','Positive']"
                        outlined
                        v-model="performance.antimicrobialResidues"
                        placeholder="Select"
                        dense
                      ></v-select>
                    </div>  
                  </v-col>                
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="mt-2">
              <v-expansion-panel-header class="text-h6"
                >Liveweight Information</v-expansion-panel-header
              >
              <v-expansion-panel-content class="pt-5">
                <v-row>
                  <v-col cols="4">
                    <label class="label">Average Daily Gain</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="performance.averageDailyGain"
                        :rules="rules.weight"
                      ></v-text-field>
                      <v-select
                        :items="['Kg']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        value="Kg"
                        dense
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Liveweight (Current)</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="performance.liveWeight"
                        :rules="rules.weight"
                      ></v-text-field>
                      <v-select
                        :items="['kg']"
                        outlined
                        class="ml-4"
                        value="kg"
                        placeholder="Unit"
                        dense
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Weaning Weight</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="performance.weaningWeight"
                        :rules="rules.weight"
                      ></v-text-field>
                      <v-select
                        :items="['kg', 'lb']"
                        outlined
                        class="ml-4"
                        value="kg"
                        placeholder="Unit"
                        dense
                        v-model="performance.weaning_weight_unit"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Birth Weight</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="performance.birthWeight"
                        :rules="rules.weight"
                      ></v-text-field>
                      <v-select
                        :items="['kg','lb']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        dense
                        value="kg"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Yearling Weight</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="performance.yearlingWeight"
                        :rules="rules.weight"
                      ></v-text-field>
                      <v-select
                        :items="['kg','lb']"
                        outlined
                        class="ml-4"
                        value="kg"
                        placeholder="Unit"
                        dense
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- <v-expansion-panel>
              <v-expansion-panel-header class="text-h6">Meat Quality</v-expansion-panel-header>

              <v-expansion-panel-content class="pt-5">
                <v-row>
                  <v-col cols="4">
                    <label class="label">Carcass Weight</label>
                    <div class="d-flex">
                      <v-text-field
                        :rules="rules.weight"
                        dense
                        outlined
                        placeholder="Enter carcass weight"
                        type="number"
                        v-model="performance.carcassWeight"
                      />
                      <v-select
                        :items="['Kg']"
                        outlined
                        class="ml-4"
                        value="kg"
                        placeholder="Unit"
                        dense
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Rib-eye Area</label>
                    <div class="d-flex">
                      <v-text-field
                        dense
                        outlined
                        placeholder="Enter rib eye area"
                        type="number"
                        v-model="performance.ribEyeArea"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Ultrasound Rib-Eye Area</label>
                    <div class="d-flex">
                      <v-text-field
                        dense
                        outlined
                        placeholder="Enter ultrasound rib eye area"
                        type="number"
                        v-model="performance.ultrasoundRibEyeArea"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Ultrasound Fat</label>
                    <div class="d-flex">
                      <v-text-field
                        dense
                        outlined
                        placeholder="Enter ultrasound fat"
                        type="number"
                        v-model="performance.ultrasoundFat"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Ultrasound Intramuscular Fat</label>
                    <div class="d-flex">
                      <v-text-field
                        dense
                        outlined
                        placeholder="Enter ultrasound intramuscular fat"
                        type="number"
                        v-model="performance.ultrasoundIntramuscularFat"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Fat Thickness</label>
                    <div class="d-flex">
                      <v-text-field
                        dense
                        outlined
                        placeholder="Enter fat thickness"
                        type="number"
                        v-model="performance.fatThickness"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Percentage of Intramuscular Fat (IMG %)</label>
                    <div class="d-flex">
                      <v-text-field
                        dense
                        outlined
                        placeholder="Enter percentage of fat"
                        type="number"
                        v-model="performance.percentageFatThickness"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Color of the Meat</label>
                    <div class="d-flex">
                      <v-text-field
                        dense
                        outlined
                        placeholder="Enter color of the meat"
                        type="text"
                        v-model="performance.meatColor"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Water Holding Capacity</label>
                    <div class="d-flex">
                      <v-text-field
                        dense
                        outlined
                        placeholder="Enter water holding capacity"
                        type="number"
                        v-model="performance.waterHoldingCapacity"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Water Holding Capacity (after 24h)</label>
                    <div class="d-flex">
                      <v-text-field
                        dense
                        outlined
                        placeholder="Enter water holding capacity (after 24h)"
                        type="number"
                        v-model="performance.waterHoldingCapacityAfter24h"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Tenderness</label>
                    <div class="d-flex">
                      <v-text-field
                        dense
                        outlined
                        placeholder="Enter tenderness"
                        type="number"
                        v-model="performance.meatTenderness"
                      />
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Lipid and Protein Oxidation</label>
                    <div class="d-flex">
                      <v-text-field
                        dense
                        outlined
                        placeholder="Enter lipid and protein oxidation"
                        type="number"
                        v-model="performance.lipidAndProteinOxydation"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel> -->
            <!-- <v-expansion-panel class="mt-2">
              <v-expansion-panel-header class="text-h6"
                >Score</v-expansion-panel-header
              >
              <v-expansion-panel-content class="pt-5">
                <v-row>
                  <v-col cols="4">
                    <label class="label">Somatic cell score</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        :rules="[(v) => v <= 999999 || 'Max limit 999999']"
                        v-model="animal.somaticCellScore"
                      ></v-text-field>
                      <v-select
                        :items="['count/ml']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        dense
                        v-model="animal.somaticCellScoreUom"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Body condition score</label>
                    <div class="">
                      <v-select
                        :items="Array.from({ length: 5 }, (_, i) => i + 1)"
                        outlined
                        placeholder="Select Body Condition Score"
                        dense
                        v-model="animal.bodyConditionScore"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Teat score</label>
                    <div class="">
                      <v-select
                        :items="Array.from({ length: 10 }, (_, i) => i + 1)"
                        outlined
                        placeholder="Select Teat Score"
                        dense
                        v-model="animal.teatScore"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Udder score</label>
                    <div class="">
                      <v-select
                        :items="Array.from({ length: 5 }, (_, i) => i + 1)"
                        outlined
                        placeholder="Select Udder Score"
                        dense
                        v-model="animal.udderScore"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Birth ease</label>
                    <div class="">
                      <v-select
                        :items="birthEaseTypes"
                        item-text="text"
                        item-value="value"
                        outlined
                        placeholder="Select Birth Ease"
                        dense
                        v-model="animal.birthEase"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Total Longevity</label>
                    <div class="">
                      <v-select
                        :items="totalLongevity"
                        item-text="text"
                        item-value="value"
                        outlined
                        placeholder="Select Total Longevity"
                        dense
                        v-model="animal.totalLongevity"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Docility</label>
                    <div class="">
                      <v-select
                        :items="Array.from({ length: 5 }, (_, i) => i + 1)"
                        outlined
                        placeholder="Select Docility"
                        v-model="animal.docility"
                        dense
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="mt-2">
              <v-expansion-panel-header class="text-h6"
                >Fertility</v-expansion-panel-header
              >
              <v-expansion-panel-content class="pt-5">
                <v-row>
                  <v-col cols="4">
                    <label class="label">Fertility</label>
                    <div class="">
                      <v-text-field
                        type="number"
                        outlined
                        placeholder="e.g. 123"
                        dense
                        v-model="animal.fertility"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Age at first calving</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="animal.ageAtFirstCalving"
                      ></v-text-field>
                      <v-select
                        :items="timeUnits"
                        item-text="text"
                        item-value="value"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        dense
                        v-model="animal.ageAtFirstCalvingUom"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Calving interval</label>
                    <div class="">
                      <v-text-field
                        type="number"
                        outlined
                        placeholder="Unit"
                        dense
                        v-model="animal.calvingInterval"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Scrotal circumference</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="animal.scrotalCircumference"
                      ></v-text-field>
                      <v-select
                        :items="['cm']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        dense
                        v-model="animal.scrotalCircumferenceUom"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Estrus detection</label>
                    <div class="">
                      <v-text-field
                        type="number"
                        outlined
                        placeholder="e.g. 123"
                        dense
                        v-model="animal.estrusDetection"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Presence of estrus</label>
                    <div class="">
                      <v-select
                        :items="['0', '1']"
                        outlined
                        placeholder="e.g. 123"
                        dense
                        v-model="animal.presenceOfEstrus"
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel class="mt-2">
              <v-expansion-panel-header class="text-h6"
                >Measurements</v-expansion-panel-header
              >
              <v-expansion-panel-content class="pt-5">
                <v-row>
                  <v-col cols="4">
                    <label class="label">Mature weight</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="animal.matureWeight"
                      ></v-text-field>
                      <v-select
                        :items="['kg']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        dense
                        v-model="animal.matureWeightUom"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Mature height</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="animal.matureHeight"
                      ></v-text-field>
                      <v-select
                        :items="['cm']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        dense
                        v-model="animal.matureHeightUom"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Foot Claw Set</label>
                    <div class="">
                      <v-select
                        :items="Array.from({ length: 9 }, (_, i) => i + 1)"
                        outlined
                        placeholder="e.g. 123"
                        dense
                        v-model="animal.footClawSet"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Pulmonary arterial pressure</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        placeholder="e.g. 123"
                        dense
                        v-model="animal.pulmonaryArterialPressure"
                      ></v-text-field>
                      <v-select
                        :items="['mmHg']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        dense
                        v-model="animal.pulmonaryArterialPressureUom"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Foot Angle</label>
                    <div class="">
                      <v-select
                        :items="Array.from({ length: 9 }, (_, i) => i + 1)"
                        outlined
                        placeholder="e.g. 123"
                        dense
                        v-model="animal.footAngle"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Rib-eye area</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        placeholder="e.g. 123"
                        v-model="animal.ribEyeArea"
                        dense
                      ></v-text-field>
                      <v-select
                        :items="['cm2']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        dense
                        v-model="animal.ribEyeAreaUom"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Ultrasound Fat</label>
                    <div class="">
                      <v-text-field
                        type="number"
                        outlined
                        placeholder="23unit"
                        dense
                        v-model="animal.ultrasoundFat"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Ultrasound Intramuscular Fat</label>
                    <div class="">
                      <v-text-field
                        type="number"
                        outlined
                        placeholder="33unit"
                        dense
                        v-model="animal.ultrasoundIntramuscularFat"
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Ultrasound Rib-Eye Area</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="2"
                        v-model="animal.ultrasoundRibEyeArea"
                      ></v-text-field>
                      <v-select
                        :items="['cm2']"
                        outlined
                        class="ml-4"
                        placeholder="cm2"
                        dense
                        v-model="animal.ultrasoundRibEyeAreaUom"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Fat thickness</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="animal.fatThickness"
                      ></v-text-field>
                      <v-select
                        :items="['cm']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        dense
                        v-model="animal.fatThicknessUom"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Marbling</label>
                    <div class="d-flex">
                      <v-text-field
                        outlined
                        type="number"
                        dense
                        placeholder="e.g. 123"
                        v-model="animal.marbling"
                      ></v-text-field>
                      <v-select
                        :items="['unit']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        dense
                        v-model="animal.marblingUom"
                      ></v-select>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <label class="label">Dry-matter intake</label>
                    <div class="d-flex">
                      <v-text-field
                        type="number"
                        outlined
                        dense
                        placeholder="e.g. 123"
                        v-model="animal.dryMatterIntake"
                      ></v-text-field>
                      <v-select
                        :items="['kg/day']"
                        outlined
                        class="ml-4"
                        placeholder="Unit"
                        dense
                        v-model="animal.dryMatterIntakeUom"
                      ></v-select>
                    </div>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel> -->
          </v-expansion-panels>
          <div class="d-flex justify-end">
            <v-btn
              @click="cancelpage"
              outlined
              right
              height="44"
              width="116"
              color="primary"
              class="mr-2 mt-15"
            >
               {{ $t("cancel") }}
            </v-btn>
            <v-btn
              right
              class="mt-15"
              height="44"
              width="116"
              color="primary"
              type="submit"
            >
              Submit
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import {
  weightUnits,
  milkUnits,
  birthEaseTypes,
  totalLongevity,
  timeUnits,
} from "@/models/units.js";

import loading from "@/mixins/LoadingMixin";

import gql from 'graphql-tag';

export default {
  computed: {
    milkColours: () => [
      'yellow',
      'white',
      'cream white',
      'white with flakes',
      'yellow with flakes',
      'red',
      'others',
    ],
    milkTastes: () => [
      'slightly sweety',
      'sour',
      'soapy bitter/ rancid flavour',
      'metalic/ cardbody',
      'feed flavor',
      'fermented',
      'putrid malty flavor',
      'cowy',
      'nutty',
      'salty',
    ],
    milkSmells: () => [
      'no smell',
      'barny odor',
      'acetone smell',
      'rotten smell',
      'others',
    ]
  },

  data() {
    return {
      panel: [],
      valid: true,
      performanceRegistered: false,
      weightUnits,
      milkUnits,
      birthEaseTypes,
      totalLongevity,
      timeUnits,
      performance: {},
      rules: {
        weight: [(v) => (v != null && v >= 0) || "Can't be less then 0"],
        currentWeight: [(v) => v >= 0 || "Can't be less then 0"],
      },
    };
  },
  methods: {    
    cancelpage() {
      this.$emit('performance:close')
    },

    updatePerformance() {
      if (!this.$refs.form.validate()) {
        this.panel = [0, 1, 2, 3];
        return;
      }
      this.startLoading();
      delete this.performance.id;
      
      this.$apollo.mutate({
        mutation: gql`mutation createPerformance($data: CreatePerformanceInput!) {
          createPerformance(createPerformanceInput: $data) {
            id
          }
        }`,
        variables: {
          data: {
            animalId: parseInt(this.$route.params.animal_number),
            daily_milk_yield: this.performance.dailyMilkYield ? parseInt(this.performance.dailyMilkYield) : null,
            daily_milk_yield_unit: this.performance.dailyMilkYieldUnit ? this.performance.dailyMilkYieldUnit: 'Kg',
            milk_colour: this.performance.milkColour,
            milk_taste: this.performance.milkTaste,
            milk_smell: this.performance.milkSmell,
            lactation_number: this.performance.lactationNumber ? parseInt(this.performance.lactationNumber) : null,
            lactation_length: this.performance.lactationLength ? parseInt(this.performance.lactationLength) : null,
            lactation_length_unit: this.performance.lactationLengthUnit ? this.performance.lactationLengthUnit : 'Days',
            milking_frequency: this.performance.milkingFrequency ? parseInt(this.performance.milkingFrequency) : null,
            average_daily_gain: this.performance.averageDailyGain ? parseInt(this.performance.averageDailyGain) : null,
            weaning_weight: this.performance.weaningWeight ? parseInt(this.performance.weaningWeight) : null,
            weaning_weight_unit: this.performance.weaning_weight_unit,
            birth_weight: this.performance.birthWeight ? parseInt(this.performance.birthWeight) : null,
            live_weight: this.performance.liveWeight ? parseInt(this.performance.liveWeight) : null,
            yearling_weight: this.performance.yearlingWeight ? parseInt(this.performance.yearlingWeight) : null,
            
            // carcass_weight: this.performance.carcassWeight ? parseInt(this.performance.carcassWeight) : null,
            // rib_eye_area: this.performance.ribEyeArea ? parseInt(this.performance.ribEyeArea) : null,
            // ultrasound_rib_eye_area: this.performance.ultrasoundRibEyeArea ? parseInt(this.performance.ultrasoundRibEyeArea) : null,
            // ultrasound_fat: this.performance.ultrasoundFat ? parseInt(this.performance.ultrasoundFat) : null,
            // ultrasound_intramuscular_fat: this.performance.ultrasoundIntramuscularFat ? parseInt(this.performance.ultrasoundIntramuscularFat) : null,
            // fat_thickness: this.performance.fatThickness ? parseInt(this.performance.fatThickness) : null,
            // percentage_fat_thickness: this.performance.percentageFatThickness ? parseInt(this.performance.percentageFatThickness) : null,
            // meat_color: this.performance.meatColor,
            // water_holding_capacity: this.performance.waterHoldingCapacity ? parseInt(this.performance.waterHoldingCapacity) : null,
            // water_holding_capacity_after_twentyfour_hours: this.performance.waterHoldingCapacityAfter24h ? parseInt(this.performance.waterHoldingCapacityAfter24h) : null,
            // meat_tenderness: this.performance.meatTenderness ? parseInt(this.performance.meatTenderness) : null,
            // lipid_and_protein_oxydation: this.performance.lipidAndProteinOxydation ? parseInt(this.performance.lipidAndProteinOxydation) : null,
          
            //TODO:: Disabled as per CFA-4708

            // physiochemicalCharacteristics:{
            //   acidity_of_raw_milk: this.performance.acidityOfRawMilk ? parseInt(this.performance.acidityOfRawMilk) : null,
            //   specific_gravity: this.performance.specificGravity ? parseInt(this.performance.specificGravity) : null,
            //   snf: this.performance.snf ? parseInt(this.performance.snf) : null,
            //   protien_content: this.performance.proteinContent ? parseInt(this.performance.proteinContent) : null,
            //   protien_content_unit: this.performance.proteinContentUnit ? this.performance.proteinContentUnit : null,
            //   fat_content: this.performance.fatContent ? parseInt(this.performance.fatContent) : null,
            //   milk_lactose: this.performance.milkLactose ? parseInt(this.performance.milkLactose) : null,
            // },
            microbiologyCharacteristics:{
              somatic_cell_count: this.performance.somaticCellCount ? this.performance.somaticCellCount : null,
              preliminary_incubation_counts: this.performance.preliminaryIncubationCounts ? this.performance.preliminaryIncubationCounts : null,
              the_california_mastitis: this.performance.californiaMastitis ? this.performance.californiaMastitis : null,
              total_viable_count: this.performance.totalViableCount ? this.performance.totalViableCount : null,
              coliform_count: this.performance.coliformCount ? this.performance.coliformCount : null,
              yeast_and_mould_count: this.performance.yeastAndMouldCount ? this.performance.yeastAndMouldCount : null,
              antimicrobial_residues: this.performance.antimicrobialResidues ? this.performance.antimicrobialResidues : null,
            }
          },
        }
      })
        .then((res) => {
          if (this.performanceRegistered) res = res.data;

          if (res.data.createPerformance || res.createPerformance) {
            this.$notify({
              title: "Animal Performance Updated Successfully",
              text: res.message,
              type: "success",
              position: "top right",
            });
            this.$emit('performance:updated');
          } else {
            this.$notify({
              title: "Animal Performance Not Updated",
              text: res.message,
              type: "error",
              position: "top right",
            });
          }
          this.stopLoading();
        })
        .catch((err) => {
          console.log(err.data);
          this.stopLoading();
        });
    },
  },

  mounted() {
    this.performance = Object.assign({}, {...this._performance,
                  //TODO:: Disabled as per CFA-4708
      // ...this._performance.physiochemicalCharacteristics,
      ...this._performance.microbiologyCharacteristics});
  },

  mixins: [loading],

  props: {
    _performance: {
      required: true,
      type: Object,
    }
  },
};
</script>
<style lang="scss" scopped>
label {
  display: inline-block;
  margin-bottom: 0.5rem;
  font-size: 14px;
  font-family: Poppins-Medium;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

.v-list-item__title {
  text-transform: capitalize;
}
</style>